import { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from './_http';

type GetPostBenefitParams = Ref<{
	tab: 'NORMAL' | 'ONE' | 'PREMIUM';
	page: number;
	row: number;
}>;
type GetPostBenefitData = {
	count: number;
	count_full: string;
	post: Benefit[];
	post_cnt: number;
};
type Benefit = {
	post_pk: number;
	post_title: string;
	post_enrollment_date: string;
	post_modifying_date: string;
	post_open_yn: number;
	post_content: string;
	post_division: string;
	post_type: string;
	post_hit: number;
	administrator_pk: number;
};
export const useGetPostBenefitApi = (params: GetPostBenefitParams) => {
	const url = '/v1/front/getPost';
	return useQuery<AxiosResponse, AxiosError, GetPostBenefitData>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => {
			return res.data?.data;
		},
	});
};

type GetPostBenefitDetailParams = {
	post_pk: number;
};
type GetPostBenefitDetailData = {
	data: {
		post: BenefitDetail[];
	};
	error: {
		code: string;
		message: string;
		response: string;
	};
};
type BenefitDetail = {
	post_pk: number;
	post_title: string;
	post_enrollment_date: string;
	post_content: string;
	post_hit: number;
	authority_group_name: number;
};
export const useGetPostBenefitDetailApi = (params: GetPostBenefitDetailParams) => {
	const url = '/v1/front/getPostDetail';
	return useQuery<AxiosResponse, AxiosError, GetPostBenefitDetailData>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data,
	});
};
